// Write your code here
import {Component} from 'react'
import {v4 as uuidv4} from 'uuid'
import './index.css'
import TransactionItem from '../TransactionItem'
import MoneyDetails from '../MoneyDetails'

const transactionTypeOptions = [
  {
    optionId: 'INCOME',
    displayText: 'Income',
  },
  {
    optionId: 'EXPENSES',
    displayText: 'Expenses',
  },
]
class MoneyManager extends Component {
  state = {
    balance: 0,
    income: 0,
    expense: 0,
    title: '',
    amount: '',
    type: 'INCOME',
    historyList: [],
  }

  inputTitle = event => {
    this.setState({title: event.target.value})
  }

  inputAmmount = event => {
    this.setState({amount: event.target.value})
  }

  inputType = event => {
    this.setState({type: event.target.value})
  }

  toCheckBalance = (amount, type) => {
    // const {amount, type} = this.state
    if (type === 'INCOME') {
      return parseInt(amount)
    }
    return -parseInt(amount)
  }

  toCheckIncome = (amount, type) => {
    // const {amount, type} = this.state
    if (type === 'INCOME') {
      return parseInt(amount)
    }
    return 0
  }

  toCheckexpense = (amount, type) => {
    // const {amount, type} = this.state
    if (type === 'EXPENSES') {
      return parseInt(amount)
    }
    return 0
  }

  onSubmit = event => {
    event.preventDefault()
    const {amount, title, type} = this.state
    const newHistort = {
      id: uuidv4(),
      amount,
      title,
      type,
    }
    // const a=0,b=0
    /* if (type === 'INCOME') {
      this.setState(prevState => ({
        income: prevState.income + amount,
        balance: prevState.balance + amount,
      }))
    } else {
      this.setState(prevState => ({
        expense: prevState.expense + amount,
        balance: prevState.balance - amount,
      }))
    } */
    // console.log(new_histort)
    this.setState(prevState => ({
      historyList: [...prevState.historyList, newHistort],
      balance: prevState.balance + this.toCheckBalance(amount, type),
      income: prevState.income + this.toCheckIncome(amount, type),
      expense: prevState.expense + this.toCheckexpense(amount, type),
      amount: '',
      title: '',
    }))
  }

  onDelete = id => {
    const {historyList} = this.state
    const a = historyList.find(every => every.id === id)
    console.log(a)
    const {amount, type} = a

    this.setState(prevState => ({
      historyList: prevState.historyList.filter(every => every.id !== id),
      balance: prevState.balance - this.toCheckBalance(amount, type),
      income: prevState.income - this.toCheckIncome(amount, type),
      expense: prevState.expense - this.toCheckexpense(amount, type),
    }))
  }
  /* updateBalance = () => {
   // const {historyList} = this.state

this.setState(prevState=>({
  income:prevState.income+prevState.historyList.map(every=>{
    if(every.type==="INCOME"){
      return every.income
    }
    return 0
}),
expense:prevState.expense+prevState.historyList.map(every=>{
    if(every.type==="EXPENSE"){
      return every.expense
    }
    return 0
}),
balance:prevState.balance+prevState.historyList.map(every=>{
    if(every.type==="INCOME"){
      return every.income
    }
    return -every.expense
})
}))
   }

   /* historyList.map(every => {
      if (every.type === 'INCOME') {
        this.setState(prevState => ({
          balance: prevState.balance + every.amount,
          income: prevState.income - every.amount,
        }))
      } else {
        //expe+=every.amount
        this.setState(prevState => ({
          balance: prevState.balance - every.amount,
          expense: prevState.expense + every.amount,
        }))
      }
    })
  } */

  render() {
    // this.updateBalance()

    const {title, amount, balance, income, expense, historyList} = this.state
    return (
      <div className="main_div">
        <div className="div_1">
          <h1>Hi, Richard</h1>
          <p>
            Welcome back to your <span>Money Manager</span>{' '}
          </p>
        </div>
        <MoneyDetails balance={balance} expense={expense} income={income} />
        <div className="div_3">
          <form className="form" onSubmit={this.onSubmit}>
            <h1>Add Transaction</h1>
            <label htmlFor="title">TITLE</label>
            <input
              placeholder="TITLE"
              onChange={this.inputTitle}
              id="title"
              type="text"
              value={title}
            />

            <label htmlFor="amount">AMOUNT</label>
            <input
              type="text"
              onChange={this.inputAmmount}
              id="amount"
              placeholder="AMOUNT"
              value={amount}
            />
            <label htmlFor="income">type</label>
            <select id="income" onChange={this.inputType}>
              {transactionTypeOptions.map(every => {
                if (every.optionId === 'INCOME') {
                  return (
                    <option value={every.optionId} key={every.optionId}>
                      {every.displayText}
                    </option>
                  )
                }
                return (
                  <option value={every.optionId} key={every.optionId}>
                    {every.displayText}
                  </option>
                )
              })}
            </select>
            <button type="submit" className="button">
              Add
            </button>
          </form>
          <ul className="history">
            <h1>History</h1>
            <li className="list">
              <p className="p2">Title</p>
              <p className="p2">Amount</p>
              <p className="p2">Type</p>
            </li>
            {historyList.map(every => (
              <TransactionItem
                key={every.id}
                onDelete={this.onDelete}
                details={every}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}
export default MoneyManager
